
import { combineReducers } from "redux";

import { createAction } from '@reduxjs/toolkit'
import * as constants from './constants'
import { IAnswers, IOptions, IProblem, ITestList } from "./types";



export const fetchTest = createAction<number>(constants.FETCH_TEST)
export const fetchProb = createAction<number>(constants.FETCH_PROB)
export const fetchList = createAction<null>(constants.FETCH_LIST)
export const setProbs = createAction<IProblem[]>(constants.SET_PROBS)
export const setTestList = createAction<ITestList>(constants.SET_TEST_LIST)
export const setOptions = createAction<IOptions>(constants.SET_OPTIONS)
export const setTimer = createAction<number>(constants.SET_TIMER)
export const setError = createAction<string>(constants.SET_ERROR)
export const moveTestAfter = createAction<[number, number]>(constants.MOVE_TEST_AFTER)
export const moveTestBefore = createAction<[number, number]>(constants.MOVE_TEST_BEFORE)



const testList = function(state: typeof initialState.testList|undefined,
    action: ReturnType<typeof setTestList> | ReturnType<typeof moveTestAfter> | ReturnType<typeof moveTestBefore>) {
        let _state = state !== undefined ? state : initialState.testList
        if (setTestList.match(action) && setTestList.type === action.type){
          return [..._state, ...action.payload]
        } else if (moveTestAfter.match(action) && moveTestAfter.type === action.type) {
            let [to_move, after_pos] = action.payload
            const nstate = [..._state]

            const deleted = nstate.splice(to_move, 1)
            if (to_move <= after_pos) {
                after_pos += -1;
            }
            nstate.splice(after_pos + 1, 0, deleted[0])
            return nstate
        } else if (moveTestBefore.match(action) && moveTestBefore.type === action.type) {
            let [to_move, before_pos] = action.payload
            const nstate = [..._state]

            const deleted = nstate.splice(to_move, 1)
            if (to_move <= before_pos) {
                before_pos += -1;
            }
            nstate.splice(before_pos, 0, deleted[0])
            return nstate
        }
        return _state
  }

const probs = function(state: typeof initialState.probs|undefined,
  action: ReturnType<typeof setProbs>) {
      let _state = state !== undefined ? state : initialState.probs
      if (setProbs.match(action)){
        return [..._state, ...action.payload]
      }
      return _state
}

const answers = function(
    state: typeof initialState.answers|undefined,
    action: undefined) {
        let _state = state !== undefined ? state : initialState.answers
        return _state
}

const options = function(state: typeof initialState.options|undefined, action: ReturnType<typeof setOptions>){
    let _state = state !== undefined ? state : initialState.options
    if (setOptions.match(action)){
        return {..._state, ...action.payload}
    }
    return _state
}

const timer = function(state: typeof initialState.timer|undefined, action: ReturnType<typeof setTimer>){
    let _state = state !== undefined ? state : initialState.timer
    if (setTimer.match(action)){
        return action.payload
    }
    return _state
}

const error = function(state: typeof initialState.error|undefined, action: ReturnType<typeof setError>){
    let _state = state !== undefined ? state : initialState.error
    if (setError.match(action)){
        return action.payload
    }
    return _state
}

export const initialState = {
    testList: [] as ITestList,
    probs: [] as IProblem[],
    answers: {} as IAnswers,
    options: {} as IOptions,
    timer: 0,
    error: "Идет загрузка"
}



const test = combineReducers({
  testList,
  probs,
  answers,
  options,
  timer,
  error
})

export type TestState = ReturnType<typeof test>
export default test
